
import * as AsyncStorage  from "./AsyncStorage";
export default AsyncStorage ;

// import { getLocalStorage, mergeItem } from "./AsyncStorage";
// export { getLocalStorage, mergeItem };